import React from "react";

import { LogsFilters } from "Api/observability/pipeline/types";

import FilterSelect from "./FilterSelect/FilterSelect";
import { FilterSelectValueMap } from "./FilterSelect/types";
import * as S from "./LogsFilter.styles";

type LogsFiltersProp = {
  filters: LogsFilters;
  selection: FilterSelectValueMap;
  onChange?: (fsvm: FilterSelectValueMap) => void;
};

const FILTER_LABELS = {
  severity: "Severities",
  service: "Services",
  instance: "Instances",
  host: "Hosts",
  command: "Commands",
  container_name: "Container Names"
};

const severitiesOrder = [
  "EMERGENCY",
  "ALERT",
  "CRITICAL",
  "ERROR",
  "WARNING",
  "NOTICE",
  "INFO",
  "DEBUG"
];

function compareLogSeverities(a, b) {
  if (severitiesOrder.indexOf(a.value) < severitiesOrder.indexOf(b.value)) {
    return -1;
  }

  if (severitiesOrder.indexOf(a.value) > severitiesOrder.indexOf(b.value)) {
    return 1;
  }

  return 0;
}

const LogsFilters = ({ filters, selection, onChange }: LogsFiltersProp) => {
  const filterLabels = Object.keys(filters.fields);

  const handleChange = (filter, newVal) => {
    const newSelection = { ...selection };
    newSelection[filter] = newVal;

    if (onChange) {
      onChange(newSelection);
    }
  };

  return (
    <S.FiltersContainer>
      Filter by
      {filterLabels.map(filterLabel => {
        const normalizedFilterLabel = FILTER_LABELS[filterLabel];

        if (filterLabel == "severity") {
          // let's sort severities from highest to the lowest one
          filters.fields[filterLabel].values.sort(compareLogSeverities);
        }

        return (
          <FilterSelect
            key={filterLabel}
            title={normalizedFilterLabel}
            value={selection[filterLabel]}
            options={filters.fields[filterLabel].values}
            onChange={newVal => {
              handleChange(filterLabel, newVal);
            }}
          ></FilterSelect>
        );
      })}
    </S.FiltersContainer>
  );
};

export default LogsFilters;
